module.exports = __webpack_public_path__ + "img/United-states_flag_icon_round.0089d6ef.svg";